import {
    SLICE_NAME,
    getDirectionKey,
    EMPTY_DIRECTION_MAPS,
} from '~SpectateStore/slices/translatedEntityIdsSlice';

export const selectTranslatedEntityIdsSlice = (state) => state[SLICE_NAME];

export const selectTranslatedEntityIdsDirectionMaps = (state, from, to) =>
    selectTranslatedEntityIdsSlice(state)[getDirectionKey(from, to)] ?? EMPTY_DIRECTION_MAPS;
